<template>
    <div class="body">
      <div class="header">
        <el-form :model="CollageSetFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          
          <el-form-item label="产品种类:">
              <el-input
                v-model="CollageSetFindDTO.largeCategory"
                placeholder="产品种类"
              ></el-input>
            </el-form-item>
            <el-form-item label="材料种类:">
              <el-input
                v-model="CollageSetFindDTO.subclass"
                placeholder="材料种类"
              ></el-input>
            </el-form-item>
            <el-button class="btn-style btn-search"  type="primary" @click="serchInfo">
              搜索
            </el-button>
            <br>
          <el-form-item>
            <el-button  class="btn-style btn-cancel" type="primary" @click="tohandleEdit">新增</el-button>
            <el-button  class="btn-style btn-delete"  type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
        <el-dialog
        text-align="center"
                :close-on-click-modal="false"
                title="新增拼版设置"
                class="order-dialog"
                width="75%"
                center
                :visible.sync="drawer"
      >
        <el-form
        ref="accountForm"
                    :model="accountForm"
                    class="demo-accountForm form-style"
        >
        <div class="accountForm-header">
        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="产品种类">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.largeCategory"
                                        placeholder="请输入产品种类"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="产品材料">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.subclass"
                                        placeholder="请输入产品材料"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="新板长">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.editionLength"
                                        placeholder="请输入新板长"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>


                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="新板宽">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.editionWide"
                                        placeholder="请输入新板宽"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="拼版边距">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.collageMargins"
                                        placeholder="请输入拼版边距"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="拼版间距">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.collageSpacing"
                                        placeholder="请输入拼版间距"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
        
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="作废尾料">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.cancelTail"
                                        placeholder="请输入作废尾料"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                              <el-form-item label="NC种类:" size="small" >
                      <el-select clearable size="small" v-model.trim="accountForm.ncType" allow-create @change="getNcProgramme()"
                                       filterable
                                      >
                                <el-option
                                    v-for="item in ncType"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                    </el-form-item>
                            </el-col>
                            <el-col :span="8">
                              <el-form-item label="NC方案:" size="small" >
                      <el-select clearable size="small" v-model.trim="accountForm.ncProgramme" allow-create
                                       filterable
                                      >
                                <el-option
                                    v-for="item in ncProgramme"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                    </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="8">
                        <el-form-item label="拼版模式:" size="small" >
                      <el-select clearable size="small" v-model.trim="accountForm.dischargeMode" allow-create
                                       filterable
                                      >
                                <el-option
                                    v-for="item in dischargeMode"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                    </el-form-item>
                  </el-col>
                        </el-row>
        
          <el-form-item >
            <el-button
              
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
          </div>
        </el-form>
      </el-dialog>
        <div style="display: flex">
          
          <!-- <el-button
            
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>

      <el-dialog title="编辑拼版设置" :visible.sync="dialogVisible"      text-align="center"
                :close-on-click-modal="false"
                class="order-dialog"
                width="75%"
                center>
        <el-form
        ref="accountForm"
                    :model="accountForm"
                    class="demo-accountForm form-style"
        >
        <div class="accountForm-header">
         
        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="产品种类">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.largeCategory"
                                        placeholder="请输入产品种类"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="产品材料">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.subclass"
                                        placeholder="请输入产品材料"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="新板长">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.editionLength"
                                        placeholder="请输入新板长"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>


                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="新板宽">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.editionWide"
                                        placeholder="请输入新板宽"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="拼版边距">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.collageMargins"
                                        placeholder="请输入拼版边距"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="拼版间距">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.collageSpacing"
                                        placeholder="请输入拼版间距"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
        
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="作废尾料">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.cancelTail"
                                        placeholder="请输入作废尾料"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">

                                <el-form-item label="NC种类:" size="small" >
                      <el-select clearable size="small" v-model.trim="accountForm.ncType" @change="getNcProgramme()" allow-create
                                       filterable
                                       
                                      >
                                <el-option
                                    v-for="item in ncType"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                    </el-form-item>

                                
                            </el-col>
                            <el-col :span="8">

                                <el-form-item label="NC方案:" size="small" >
                      <el-select clearable size="small" v-model.trim="accountForm.ncProgramme" 
                                      >
                                <el-option
                                    v-for="item in ncProgramme"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                    </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="8">
                        <el-form-item label="拼版模式:" size="small" >
                      <el-select clearable size="small" v-model.trim="accountForm.dischargeMode" allow-create
                                       filterable
                                      >
                                <el-option
                                    v-for="item in dischargeMode"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                    </el-form-item>
                  </el-col>
                        </el-row>
          <el-button  @click="dialogVisible = false">取 消</el-button>
          <el-button  type="primary" @click="editAccount()">
            确 定
          </el-button>
        </div>
        </el-form>
       
      </el-dialog>
      <password ></password>
      <div class="pagination">
                    <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="设置时间"
            width="175"
          ></el-table-column>
          <el-table-column
            prop="largeCategory"
            align="center"
            label="产品种类"
          ></el-table-column>
          <el-table-column
            prop="subclass"
            align="center"
            label="材料种类"
          ></el-table-column>
          <el-table-column
            prop="editionLength"
            align="center"
            label="新板长"
          ></el-table-column>
          <el-table-column
            prop="editionWide"
            align="center"
            label="新板宽"
          ></el-table-column>
          <el-table-column
            prop="collageMargins"
            align="center"
            label="拼版边距"
          ></el-table-column>
          <el-table-column
            prop="collageSpacing"
            align="center"
            label="拼版间距"
          ></el-table-column>
          <el-table-column
            prop="cancelTail"
            align="center"
            label="作废尾料"
          ></el-table-column>
          <el-table-column
            prop="ncType"
            align="center"
            label="NC种类"
          ></el-table-column>
          <el-table-column
            prop="ncProgramme"
            align="center"
            label="NC方案"
          ></el-table-column>
          <el-table-column
            prop="dischargeMode"
            align="center"
            label="排版模式"
          ></el-table-column>
               <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success"  @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>
      
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

  </template>
  
  <script>
    import password from '@/components/password.vue';
  import { selectCollageSet,bathDeleteCollageSet,addCollageSet,upDateCollageSet,selectAllOrdinary,selectAllBorderlessGraveSet,selectAllSuperSet,selectAllBacklitCharactersSet,selectPanelName,selectCarvingName} from '@/api/set/collage.js'
  export default {
    components: {
      password
  },
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]
  
        },
        date: '',
        conTract: [],
        CollageSetFindDTO:{
          access:'',
            startTime: '',
            endTime: '',
            category: '',
            productionProcesses:''
        },
        ncProgramme:[],
        ncType:["普通切割","无边字面板","超级字","背光字","迷你字面板反铣","迷你字面板不反铣","迷你字底板","UV巡边路径"],
        dischargeMode:["混合优排","按套优排","混合优排(UV激光切割)","按套分段排版","测试","四角装夹拼版","翻转排版","上夹子排版(洛克斯)"],
        category:[],
        drawer: false,
        dialogVisible:false,
        accountForm:{
          id:'',
          access:'',
          largeCategory:'',
          subclass:'',
          editionLength:'',
          editionWide:'',
          collageMargins:'',
          collageSpacing:'',
          cancelTail:'',
          ncType:'',
          ncProgramme:'',
          dischargeMode:''
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        }

      }
    },
    
  
    mounted() {
      this.CollageSetFindDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
    
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      getNcProgramme(){
        if(this.accountForm.ncType==='普通切割'){
          selectAllOrdinary(this.accountForm.access).then((res) => {
            this.accountForm.ncProgramme=''
          this.ncProgramme = res.data.data
        })}else if(this.accountForm.ncType==='无边字面板'){
          selectAllBorderlessGraveSet(this.accountForm.access).then((res) => {
            this.accountForm.ncProgramme=''
          this.ncProgramme = res.data.data
        })
        }else if(this.accountForm.ncType==='超级字'){
          selectAllSuperSet(this.accountForm.access).then((res) => {
            this.accountForm.ncProgramme=''
          this.ncProgramme = res.data.data
        })
        }
        else if(this.accountForm.ncType==='背光字'){
          selectAllBacklitCharactersSet(this.accountForm.access).then((res) => {
            this.accountForm.ncProgramme=''
          this.ncProgramme = res.data.data
        })
        }
        else if(this.accountForm.ncType==='迷你字面板反铣'||this.accountForm.ncType==='迷你字面板不反铣'){
          selectPanelName(this.accountForm.access).then((res) => {
            this.accountForm.ncProgramme=''
          this.ncProgramme = res.data.data
        })
        }
        else if(this.accountForm.ncType==='迷你字底板'){
          selectCarvingName(this.accountForm.access).then((res) => {
            this.accountForm.ncProgramme=''
          this.ncProgramme = res.data.data
        })
        }
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      getTableData() {
        selectCollageSet(this.currentPage, this.pageSize, this.CollageSetFindDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addCollageSet(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
   //修改
   editAccount() {
    upDateCollageSet(this.accountForm).then((res) => {
          console.log(res.status)
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getTableData()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeleteCollageSet(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     
  
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
  
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.CollageSetFindDTO.startTime = e[0]
          this.CollageSetFindDTO.endTime = e[1]
        } else if (!e) {
          this.CollageSetFindDTO.startTime = ''
          this.CollageSetFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
      categorySelect(e) {
                if(e.target.value) { 
                    this.accountForm.category = e.target.value
            }
        },
        
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin: 20px;
  }
  
  .body {
      overflow: auto;
  }
  
  .pagination {
      margin-top: 10px;
      margin-right: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: relative;
  }
  
  .el-pagination ::v-deep.el-pagination__total {
      line-height: 36px;
  }
  
  .el-table .warning-row {
      background: oldlace;
  }
  
  .el-table .success-row {
      background: #f0f9eb;
  }
  .goodsTableData{
      margin: 20px 0 ;
  }
  .btn-style{
      min-width: 72px;
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-buy{
      background: #FF8429;
  }
  .btn-print{
      background: #4093FF;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  .btn-view{
      background: var(--theme-color);
  }
  .product-form .el-form-item{
      margin-bottom: 0;
  }
  .table-content{
      margin: 20px;
  }
  .check-all{
      color: #333;
      font-size: 16px;
      margin-right: 20px;
      cursor: pointer;
  }
  .el-pagination{
      margin: 0;
  }
  
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  
  .table-label{
      color: var(--secondColor);
  }
  .table-value{
      color: var(--color);
  }
  .table-info{
      width: 80%;
      justify-content: space-between;
  }
  .table-info > p{
      display: inline-block;
      width: 150px;
      padding-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-shrink: 0;
  }
  .table-item{
      background: #F7F7F7;
      margin: 8px 0;
      border-radius: 12px;
      padding: 12px;
  }
  .table-image{
      width: 100px;
      height: 50px;
      margin-right: 20px;
  }
  ::v-deep.table-image .image-slot{
      height: 50px;
      display: flex;
      align-items: center;
  }
  ::v-deep.table-image .image-slot i{
      font-size: 50px;
  }
  .pay{
      color:var(--theme-color);
  }
  .no-pay{
      color:#FF4D4D;
  }
  .btn-group{
      display: flex;
      flex-direction: column;
      gap: 10px;
  }
  .btn-group .el-button{
      border-radius: 20px;
      width: 76px;
  }
  .btn-collection{
      background: #F9DDDD;
  }
  .btn-view-detail{
      background: #D3F2E4;
      color: var(--theme-color);
  }
  .btn-reckon{
      background: rgb(245, 233, 212);
    
  }
  
  ::v-deep.order-dialog .el-dialog{
      border-radius: 24px;
  }
  .operator label{
      letter-spacing: 5px;
  }
  ::v-deep.dialog-upload{
      display: flex;
  }
  ::v-deep.dialog-upload .el-form-item__label{
      flex-shrink: 0;
  }
  ::v-deep.dialog-upload .el-form-item__content{
      justify-content: right;
  }
  ::v-deep.dialog-upload .avatar-uploader{
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #D8E0DD;
  }
  ::v-deep.dialog-upload .el-upload--text{
      width: 100%;
      height: 100%;
  }
  ::v-deep.dialog-upload img{
      max-width: 100px;
  }
  .accountForm-header{
      background: #F7F7F7;
      border-radius: 16px;
      margin-bottom: 20px;
      padding: 20px;
  }
  .btn-add{
      background: #FF8429;
      border-radius: 8px;
  }
  .form-submit{
      background: var(--theme-color);
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .table-no-pay{
      background: #ffeded;
  }
  
  ::v-deep.el-icon-remove-outline{
      font-size: 32px;
      color: #a3d8f9cc;
  }
  </style>
  